import { Add, Edit } from "@mui/icons-material";

const  mo = {
    Category_Name:"Ангилал",
    Filter:"Шүүлтүүр",
    Search_Key:"Хайлтын утга",
    Status:"Төлөв",
    Search:'Хайх',
    Product_List:"Бүтээгдэхүүнүүд",
    Add_New:"Шинээр нэмэх",
    Product_Name:"Бүтээгдэхүүний нэр",
    Sku:"Ску",
    Quantity:"Тоо хэмжээ",
    Price:"Үнэ",
    Cross_Price:"Нийт үнэ",
    Type:"Төрөл",
    Action:"Үйлдэл",
    No_Data_Found:"Өгөгдөл олдсонгүй",
    Edit_Category:"Ангилал засах",
    Add_Category:"Ангилал нэмэх",
    Parent_Category:"Парент ангилал",
    Category_Description:"Ангилалын тайлбар",
    Category_List:"Ангилалууд",
    Save:"Хадгалах",
    Reset:"Дахин тохируулах",
    Category:"Ангилал",
    SubCategory:"Дэд ангилал",
    From_When:"Хэзээ (хуанли)",
    From_Where:"Хаанаас",
    Production_Method:"Боловсруулалтын төрөл",
    Product_Ref_Type:"Бүтээгдэхүүний төрлүүд",
    Short_Decription:"Тайлбар",
    Product_Images:"Бүтээгдэхүүний зураг болон бичлэг",
    Description:"Тайлбар",
    First_Name:"Эцэг /эх/-ийн нэр",
    Last_Name:"Өөрийн нэр",
    Email:"И-Мэйл",
    Password:"Нууц үг",
    Change_Password:"Өөрчлөх Нууц үг",
    Gender:"Хүйс",
    Mobile:"Гар утасны дугаар",
    Add_Product:"Бүтээгдэхүүн нэмэх",
    Edit_Product:"Засварлах",
    Cancel:"Цуцлах",
    Current_Password:"Одоогийн нууц үг",
    New_Password:"Шинэ нууц үг",
    Confirm_Password:"Нууц үг батлах",
    Buyer_List:"Худалдан авагчид",
    Seller_List:"Нийлүүлэгчид",
    Total_Seller:"Нийт нийлүүлэгчид",
    Total_Buyer:"Нийт худалдан авагчид",
    Total_Category:"Нийт ангилал",
    Total_Product:"Нийт бүтээгдэхүүн",
    Order_Status:"Захиалгын төлөв",
    Payment_Status:"Төлбөрийн төлөв",
    Order_List:"Захиалгууд",
    Invoice_No:"Нэхэмжлэхийн дугаар",
    Order_Date:"Захиалгын огноо",
    Total_Qty:"Нийт тоо хэмжээ",
    Amount:"Дүн",
    Service_Fee:"Үйлчилгээний төлбөр",
    Total_Amount:"Нийт дүн",
    S_Fee_Status:"Төлбөрийн төлөв",
    Payment_Details:"Төлбөрийн дэлгэрэнгүй мэдээлэл",
    Back:"Буцах",
    View_Order_Details:"Захиалгын дэлгэрэнгүй мэдээлэл харах",
    Order_Detail:"Захиалгын дэлгэрэнгүй мэдээлэл",
    Order:"Захиалга",
    Total_Payment_Status:"Нийт төлбөрийн төлөв",
    Shipping_Address:"Хүргэлтийн хаяг",
    nearby:"ойролцоо",
    Download_Invoice:"Нэхэмжлэх татаж авах",
    Download:"Татаж авах",
    Item_Details:"Дэлгэрэнгүй",
    Item_Quantity:"Тоо хэмжээ",
    Item_Price:"Үнэ",
    Total_Price:"Нийт үнэ",
    Payment_Information:"Төлбөрийн мэдээлэл",
    Payment_Method:"Төлбөрийн төрөл",
    Payment_Date:"Төлбөрийн огноо",
    Payment_Amount:"Төлбөрийн хэмжээ",
    Order_Summary:"Захиалгын хураангуй",
    Items:"Төрөл",
    Order_Total:"Нийт_Захиалга",
    Payment_Upload:"Төлбөр төлөх",
    Upload_Sell:"Зарах мэдээлэл нэмэх",
    Upload_Buy:"Зарах мэдээлэл Авах",
    Payment:"Төлбөр",
    Verify:"Батлах",
    Verified:'Баталгаажсан',
    Processing:'Боловсруулж байна',
    Order_Placed:'Захиалга өгсөн',
    From_Bank:"Банкнаас",
    Bank_Name:"Банкны нэр",
    Transaction_ID_optional:"Шилжүүлгийн ID (оновчлол)",
    Upload_Screenshot:"Screenshot хийх",
    Submit:"Зөвшөөрөх",
    Email_Address_Username:"И-Мэйл / Хэрэглэгчийн нэр",
    Remember_me:"Намайг сана",
    Sign_in:"Нэвтрэх",
    Sign_in_with_Email_address:"И-Мэйл хаягаар нэвтрэх",
    Branch_Name:"Салбарын нэр",
    Account_Name_As_Per_Bank:"Дансны Нэр(Банкны хувьд)",
    Ifsc_Code:"Дансны банкны код",
    Pin_Code:"Пин_Код",
    Address:"Хаяг",
    Bank_QR_Code:"Банкны QR код",
    Updating:"Шинэчилж байна...",
    Update:"Шинэчлэх",
    Bag:"Сагс",
    empty_bag:"хоосон сагс",
    Hey_it_feels_so_light:"Таны сагс их хөнгөн байна шүү",
    There_is_nothing_in_your_bag_Let_is_add_some_items:"Таны сагсанд юу ч алга байна шүү дээ, ямар нэг захиалга хийгээрэй!",
    Nothing_Here:"Хоосон байна!",
    Forgot_Password:"Нууц үг мартсан",
    Back_to_Home:"Үндсэн дэлгэц руу буцах",
    Send:"Илгээх",
    Please_Wait:"Түр хүлээнэ үү...",
    Code:"Код",
    Password_Mismatch:"Нууц үг таарахгүй байна",
    Create_New_Account:"Шинээр Аккаунт үүсгэх",
    User_Email_Mobile:"Хэрэглэгчийн И-Мэйл/Гар утасны дугаар",
    Login_to_your_account:"Өөрийн Аккаунт-руу нэвтрэх",
    Thank_you_for_ordering_with_us:"Биднийг сонгож захиалга өгсөн танд баярлалаа :)",
    Please_check_your_mail_or_download_invoice_for_payment:"Та өөрийн И-Мэйл хаягаа шалгана уу, эсвэл төлбөрийн нэхэмжлэхээ татаж авна уу.",
    Recieved_Proposals:"Хүлээн авсан саналууд",
    Nothing_to_Show:"Мэдээлэл олдсонгүй...",
    Send_Proposals:"Саналууд илгээх",
    ID:"ID",
    Customer_Name:"Хэрэглэгчийн нэр",
    Qty:"Тоо хэмжээ",
    Created_Date:"Үүсгэсэн огноо",
    Details:"Дэлгэрэнгүй",
    About_Product:"Бүтээгдэхүүний тухай",
    Quantity_Kg:"Тоо хэмжээ (Кг)",
    Go_to_Bag:"Сагсанд хийх",
    Buy_Now:"Авах",
    Average_Market_Price:"Зах зээлийн дундаж үнэ",
    Name:"Нэр",
    Seller:"Нийлүүлэгч",
    Buyer:"Худалдан авагч",
    Country:"Улс",
    City:"сум",
    State:"Аймаг",
    Current_Address_2:"Одоогийн хаяг 2",
    Current_Address_1:"Одоогийн хаяг 1",
    I_have_read_and_agree_to_nm:"Би 9999.mn вебсайт болон АПП-ын үйлчилгээний нөхцөл болон хэрэглэгчийн хамтран ажиллах гэрээ, нууцлалын бодлого-ын бүхий л нөхцөлтэй сайтар уншиж танилцсан бөгөөд бүхий л үйлчилгээний нөхцлийг хүлээн зөвшөөрч байгаа болно.",
    User_Agreement_and_Privacy_Policy:"9999.mn вебсайт болон АПП-ын үйлчилгээний нөхцөл болон хэрэглэгчийн хамтран ажиллах гэрээ, нууцлалын бодлого.",
    Sign_up:"Бүртгүүлэх",
    Create_Account:"Аккаунт_үүсгэх",
    User_Agreement:"Хэрэглэгчийн хамтран ажиллах гэрээ",
    Close:"Хаах",
    Disclaimer_text:'Disclaimer: Termly Inc is not a lawyer or a law firm and does not engage in the practice of law or provide legal advice or legal representation. All information, software, services, and comments provided on the site are for informational and self-help purposes only and are not intended to be a substitute for professional legal advice. Use of this site is subject to our Terms of Use. Adding an “agree to terms and conditions” checkbox will likely require some coding on your website. You will also need to make sure you have accurate and up-to-date information in your terms and conditions. If you need assistance creating or updating your terms and conditions, Termly has a free terms and conditions generator. It allows you to choose the agreements for your business’s particular needs and decide exactly how you want them displayed. You can also use a template or choose to write your own terms and conditions.',
    Category_Average_Price: 'Ангилал Дундаж үнэ',
    Bank_Details:'Банкны дэлгэрэнгүй мэдээлэл',
    My_Address:'Миний хаяг',
    Search_Your_Product:'Бүтээгдэхүүн хайх',
    Explore:'Судлах',
    Start_Shopping:'Худалдан авалт эхлэх',
    Explore_More:'Дэлгэрэнгүй',
    BuySell_Text_1:'uy & Биднээс хамгийн сайн зах зээлийн дундаж үнийг зарна.',
    BuySell_Text_2:'100 гаруй нэр төрлийн бүтээгдэхүүн.',
    Add_New_Address:'Шинэ хаяг нэмэх',
    Do_you_Really_wants_Delete_address:'Та энэ хаягийг устгахдаа итгэлтэй байна уу?', 
    Edit:'Засах',
    Remove:'Устгах',
    Categories:'Ангилал',
    Mobile_No:'Гар утасны дугаар.',
    Full_Name:'Нэр',
    Flat_House_no_Building:'Гэрийн хаяг',
    Area_Colony_Street:'Гудамж',
    Near_By:'Ойролцоо',
    Town_City:'Аймаг/Дүүрэг',
    Remove_from_Bag:'Сагснаас устгах',
    Qnty:'Тоо хэмжээ.',
    Proceed_to_Checkout:'Үргэлжлүүлэх',
    Price_Details:'Үнийн мэдээлэл',
    Total:'Нийт',
    Please_Add_bank_details_first:'Банкны мэдээллийг оруулна уу!',
    item:'төрөл',
    Proposal_sent:'Санал илгээгдсэн!',
    Please_Login_to_continue:'Нэвтэрнэ үү',
    Proposal_Accepted:'Санал зөвшөөрөгдсөн!',
    Proposal_is_Re_proposed:'Дахин санал болгож байна',
    Proposal_Rejected:'Санал татгалзсан!',
    Above_proposal_is:'Дээрх санал бол',
    Proposed_Price:'Санал болгосон үнэ',
    Loading:'Ачаалж байна ...',
    Limit_Exceeded:'Хэмжээ хэтэрсэн ! ',
    KG:'кг',
    Kg:'кг',
    View_Detail:'Дэлгэрэнгүй',
    Praposal_Details:'Саналын дэлгэрэнгүй',
    Product_Details:'Бүтээгдэхүүний дэлгэрэнгүй',
    Go_to_Praposal:'Санал харах',
    Add_Praposal:'Үнийн санал өгөх',
    Sell_Now:'Зарах',
    Login:'Нэвтрэх',
    Ragister:'Бүртгүүлэх',
    View_all:'Бүгдийг харах',
    No_Message_Found:'Мессеж олдсонгүй',
    Logout:'Гарах',
    My_Orders:'Миний захиалга',
    My_Products:'Миний бүтээгдэхүүн',
    My_Proposals:'Миний санал',
    Profile:'Профайл',
    Buy_Sell_Made_Easy_Powered_by_Vstacks:'Powered by 9999.mn',
    No_Item_to_show:'Хайлт олдсонгүй',
    Place_Order:'Захиалга өгөх',
    Total_Products:'Нийт бүтээгдэхүүн',
    Delivery_Date:'Хүргэлтийн огноо *',
    Discount:'Хямдрал',
    Service_Tax:'Үйлчилгээний хураамж',
    Subtotal:'Дүн',
    Confirm_Order:'Захиалгыг батлах',
    Internal_server_error:'Серверийн алдаа гарлаа. Та дахин оролдоно уу!',
    Order_Successfull:'Захиалга амжилттай!',
    Account_registered_successfully:'Аккаунт амжилттай бүртгэгдлээ!',
    Invalid_Link:'Буруу холбоос /Link/. Админтай холбогдоно уу!',
    Account_Verified:'Аккаунт баталгаажлаа. Дахин холбогдож байна! ',
    Something_went_wrong:'Алдаа гарлаа. Дахин оролдоно уу!',
    Default_Address_Updated:'Хаяг шинэчлэгдсэн!',
    Address_Deleted:'Хаяг устгагдсан!',
    Address_Updated:'Хаяг шинэчлэгдсэн!',
    Address_Added:'Хаяг нэмэгдсэн!',
    Seller_Account_Missing:'Нийлүүлэгч худалдан авалт хийх боломжгүй, худалдан авагч эрхээр бүртгүүлнэ үү!',
    Product_Added_Bag:'Бүтээгдэхүүн сагсанд нэмэгдлээ!',
    Some_Error_Occurred:'Ямар нэг алдаа гарлаа!',
    Product_Removed_from_Bag:'Бүтээгдэхүүн сагснаас хасагдлаа!',
    Logged_out_successfully:'Амжилттай гарлаа!',
    Logged_In_successfully:'Амжилттай нэвтэрлээ!',
    Signed_Up_Successfully:'Амжилттай бүртгэгдлээ, и-мэйл хаягаа шалгаж баталгаажуулна уу!',
    Preparing_For_Dispatch:'Илгээхэд бэлтгэж байна...,',
    Out_for_Delivery:'Хүргэлт эхэлсэн байна!',
    Delivered:  "Хүргэгдсэн",
  Bank_Details:  "Банкны дэлгэрэнгүй",
  My_Address:  "Манай хаяг",
  Delivery_Status_changed_Successfully:  "Хүргэлтийн төлөв амжилттай өөрчлөгдлөө!",
  Please_Select_or_Add_ddress:  "Хаягаа сонгох эсвэл нэмнэ үү",
  Delivery_Date_missing:  "Хүргэлтийн огноог оруулна уу!",
  Already_have_an_account:  "Та аль хэдийн бүртгэгдсэн байна",
  You_not_register_for_category:  "Та энэ ангилалд бүртгүүлээгүй байна.",
  Account_No:  "Дансны дугаар",
  Online:  "Онлайн",
  Upload_Sell:  "Зарах мэдээлэл нэмэх",
  Upload_Buy:  "Худалдан авах мэдээлэл нэмэх",
  Delivered_By:  "Хүргэгдсэн",
  Change_Order_Status:  "Захиалгын төлөвийг өөрчлөх",
  Complete_Delivery:  "Хүргэлтийг дуусгах",
  Pay_Now:  "Одоо төлөх",
  Are_you_sure:  "Та итгэлтэй байна уу?",
  Iban_No:  "IBAN дугаар",
  select_category:  "-- Ангилал сонгох --",
  Set_price_Range:  "Үнийн хязгаарыг тогтоох",
  Min_Price:  "Хамгийн бага үнэ",
  Max_Price:  "Хамгийн их үнэ",
  Price_Range:  "Үнийн хязгаар",
  Display_Only:  "Зөвхөн дэлгэц",
  Allowed_Price_Aange:  "Зөвшөөрөгдсөн үнийн хязгаар",
  Price_Low:  "Таны үнэ зах зээлийн буюу зааж өгсөн үнийн хязгаараас их эсвэл тэнцүү байх ёстой",
  Price_High:  "Таны үнэ зах зээлийн буюу зааж өгсөн үнийн хязгаараас бага эсвэл тэнцүү байх ёстой",
  Invalid_price:  "Үнийн хязгаар буруу байна",
  View_All_Proposals:  "Бүх саналыг харах",
  Proposals_Detail:  "Саналын дэлгэрэнгүй",
  Plese_Login_as_buyer_to_add_proposal_on_this_product:  "Мэдээлэл оруулахын тулд системд худалдан авагч эрхээр нэвтэрнэ үү",
  Plese_Login_as_seller_to_add_proposal_on_this_product:  "Мэдээлэл оруулахын тулд системд нийлүүлэгчийн эрхээр нэвтэрнэ үү",
  Category_Frontend_Settings:  "Ангилалын нүүр хэсгийн тохиргоо - ",
  Transportation_Categories:  "Тээврийн төрөл",
  Product_Categories:  "Бүтээгдэхүүний ангилал",
  Category_Type:  "Ангилалын төрөл",
  select_userType:  "-- Хэрэглэгчийн төрөл сонгох --",
  Transport_Type:  "Тээврийн төрөл",
  To_Where:  "Хаашаа",
  Transport_Time:  "Тээвэрлэлтийн давтамж",
  Countof_Transportation:  "Автомашин/вагоны тоо, ширхэг",
  Quantity_Tonne:  "Бүтээгдэхүүний тоо хэмжээ (Тонн-оор)",
  Tonne:  "Тонн",
  Order_Now:  "Одоо захиалах",
  Upload_Orderer:  "Тээврийн захиалга нэмэх",
  Upload_Transport:  "Тээвэрлэх мэдээлэл нэмэх",
  Orderer:  "Захиалагч",
  Transporter:  "Тээвэрлэгч",
  Reservation_Msg:  "9999.mn сайтаар дамжуулан бидэнд захиалга өгсөн танд баярлалаа. Өгөгдсөн холбоо барих мэдээллээр бидэнтэй холбогдоно уу, бид танд шуурхай туслахад баяртай байх болно..",
  Contact_Information:  "Бидэнтэй холбоо барих",
  Reservation:  "Захиалга",
  Reservation_Summery:  "Захиалгын хураангуй",
  Book_Reservation:  "Захиалгууд",
  Confirm_Reservation:  "Захиалгыг батлах",
  Reservation_Successfull:  "Захиалга амжилттай",
  Thank_Booking:  "Бидэнтэй хамтарч буй танд баярлалаа.",
  Add_Orderer:  "Захиалагч нэмэх",
  Add_Transporter:  "Тээвэрлэгч нэмэх",
  Edit_Transporter:  "Тээвэрлэгч засварлах",
  Edit_Orderer:  "Захиалагч засварлах",
  Transporter_List:  "Тээвэрлэгчийн жагсаалт",
  Orderer_List:  "Захиалагчийн жагсаалт",
  Add_Buyer:  "Худалдан авагч нэмэх",
  Add_Seller:  "Нийлүүлэгч нэмэх",
  Edit_Seller:  "Нийлүүлэгч засварлах",
  Edit_Buyer:  "Худалдан авагч засварлах",
  One_Time:  "Нэг удаагийн",
  Long_Term:  "Урт хугацаанд",
  Mining_Seller:"Худалдагч (Уул уурхай)",
  Mining_Buyer:"Худалдан авагч (Уул уурхай)",
  Mining_Buy_Sell_Category_Alert:"Зөвхөн уул уурхайн худалдан авагч эсвэл худалдагч хэрэглэгчид Buy/Sell ангилалд зөвшөөрөгдөнө.",
  My_Reservations: "Миний захиалгууд",
  Mining:'Уул уурхай',
}

export default mo;
